import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Map full item objects to the compact payload the backend AI expects.
function toPayload(items) {
  return items.map((r) => ({
    id: r.id,
    name: r.name ?? r.original,
    type: r.type,
    path: r.path,
    parent: r.parent,
    depth: r.depth,
    ext: r.ext,
  }));
}

export async function suggestRenames({ items, instruction, preset }) {
  const { data } = await axios.post(`${API}/rename/suggest`, {
    items: toPayload(items),
    instruction: instruction || "",
    preset: preset || null,
  });
  return data;
}

export async function chatWithAssistant({ sessionId, message, items }) {
  const { data } = await axios.post(`${API}/chat`, {
    session_id: sessionId,
    message,
    items: toPayload(items),
  });
  return data;
}
